import React, { useState, useRef, useContext, useEffect } from "react";
import insites from "../../assets/images/insight.png";
import { FilterContext } from "../../context/Filter";
import Group from "../../assets/images/Group.svg";
import arrowup from "../../assets/images/arrowup.svg"
import arrowdown from "../../assets/images/down-arrow.svg"
import vdetail from "../../../src/assets/images/RTO-Detail.svg";

import {
  fetchRetosCount,
  fetchActiveAMCCount,
  fetchoprncomptable,
  fetchsampoornaTotalCouponVailed,
  fetchproblemAreaWithDistinctChassis,
  fetchownershipLoadCount,
  fetchamcContractDueNextOneMData,
  fetchvehiclesInsuranceExpeNintydays,
  fetchtotalComplaintsStatusOpen,
  getfreeservice,
  fetchsixMonthPurchaseQuantity,
  fetchlastServiceDateLoad,
  fetchsampoornaTotalCouponBalance,
  fetchsampoornaTotalCouponExpired,
  fetchsampoornaTotalCouponGenerated,
  fetchsampoornaTotalCouponIssued,
  vehicleAMcCountDetails,
  fetchlastPurchahed,
  fetchvehicleAMcCountDetails,
  fetchretropendingcount,
  fetchamcvalidcount,
  fetchfreeSeriveCount,
  fetchretropendingtabledata,
  fetchamctable,
  fetchinsightsproblem,
  fetchoprencomptable,
  fetchcouponissuedtb,
  fetchlastservicetb,
  fetchopencompnestedtable,
  fetchamcduetable,
  fetchamcduecontracttable,
  fetchvehicle7yearstable,
  fetchvehiclesevenyearstable,
  fetchontime,
  fetchdelaycards,
  fetchsixqtytable,
  fetchontimetb,
  fetchSampoornaDataOnTime,
  fetchVehicalsInsights,
  fetchtotalVehicalsInsights
} from "./apiInsights";
import BasicModal from "../Modals/BasicModal";
import Goldaccdetailstable from "../ChildData/Goldaccdetailstable";
import SimpleTable from "./Insitetable";
import AmcTable from "./Amctable";
import InsTable from "./Insurancetable";
import mousepointer from "../../assets/images/mouse_hand.png";
import ServiceTable from "./Servicetable";
import Opencomplainttb from "./Opencomplainttable";
import Couponissuedtb from "./Couponissuetable";
import Lastpurchasetb from "./LastPurchasetable";
import Lastservicetable from "./Lastservicetable";
import Vehicltable from "./Vehiclesevenyeartable";
import Sixtydaystable from "./Sixtydaystable";
import Ontimetable from "./Ontimetable";
import referalicon from "../../assets/referalicon.png";
import Moretimetable from "./Moretimetable";
import Amcduenextmonthtb from "./Amcduenextmonthtb";

const AccordionItem = ({
  title,
  children,
  getretrocount,
  getontimetb,
  getsixqtytable,
  getOntime,
  getMoretime,
  getVehicleseveryears,
  getAmcDueTableData,
  getamccduetabledata,
  getlastservicetb,
  getcouponissuedtb,
  getopencomptb,
  getproblemarea,
  getFreeService,
  getamctable,
  getretrotable,
  getfreeservice,
  getvehiclesInsuranceExpeNintydays,
  getproblemAreaWithDistinctChassis,
  gettotalVehicalsInsights,
  getamcvalidcountt,
  getownershipLoadCount,
  getamcContractDueNextOneMData,
  getlastServiceDateLoad,
  getsampoornaTotalCouponVailed,
  gettotalComplaintsStatusOpen,
  getsixMonthPurchaseQuantity,
  getsampoornaTotalCouponBalance,
  getsampoornaTotalCouponExpired,
  getsampoornaTotalCouponGenerated,
  getsampoornaTotalCouponIssued,
  getRetoData,
  getActiveAMCData,
  getvehicleinsights,
  getvehicleAMcCountDetails,
  getlastPurchahed,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { superArn: arn, childArn } = useContext(FilterContext);
  const { superArn: ParArn } = useContext(FilterContext);

  const { superArn } = useContext(FilterContext);

  const finalArn = childArn || superArn;

  const payload1 = { arn: finalArn };

  const key = childArn ? "childArn" : "parArn";
  const value = childArn || ParArn;
  const payload = { [key]: value };

  const itemRef = useRef(null);

  useEffect(() => {
    setIsOpen(false);
  }, [arn, ParArn, childArn]);

  const handleToggle = () => {
    if (!arn) {
      console.warn("ARN is missing. Accordion cannot be opened.");
      return;
    }

    if (!isOpen) {
      getRetoData(arn);
      getActiveAMCData(payload);
      getvehicleAMcCountDetails(payload1);
      getlastPurchahed(payload1);
      getlastServiceDateLoad(payload1);
      getsampoornaTotalCouponIssued(payload1);
      getsampoornaTotalCouponGenerated(payload1);
      getsampoornaTotalCouponExpired(payload1);
      getsampoornaTotalCouponBalance(payload1);
      gettotalComplaintsStatusOpen(payload1);
      getsixMonthPurchaseQuantity(payload1);
      getsampoornaTotalCouponVailed(payload1);
      getvehiclesInsuranceExpeNintydays(payload);
      getamcContractDueNextOneMData(payload1);
      getownershipLoadCount(payload1);
      getproblemAreaWithDistinctChassis(payload1);
      gettotalVehicalsInsights(payload)
      getamcvalidcountt(payload);
      getfreeservice(payload);
      getretrocount(payload);
      getretrotable(payload);
      getamctable(payload);
      getFreeService(payload);
      getproblemarea(payload);
      getopencomptb(payload1);
      getcouponissuedtb(payload1);
      getlastservicetb(payload1);
      getAmcDueTableData(payload1);
      getVehicleseveryears(payload);
      getOntime(payload);
      getsixqtytable(payload1);
      getMoretime(payload);
      getontimetb(payload);
      getvehicleinsights(payload)
      // getopencompinsidetb(payload1)
      fetchSampoornaOnTimeData(payload)
    }

    setIsOpen(!isOpen);

    setTimeout(() => {
      if (itemRef.current) {
        itemRef.current.scrollIntoView({
          behavior: "smooth",
          block: isOpen ? "end" : "start",
        });
      }
    }, 100);
  };

  const fetchSampoornaOnTimeData = async (payload) => {
    try {
      const response = await fetchSampoornaDataOnTime(payload)
    } catch (error) {
      console.error("Error", error)
    }
  }

  return (
    <div ref={itemRef} className="border-b">
      <button
        onClick={handleToggle}
        className="w-full flex border rounded-lg justify-between items-center p-2 bg-[linear-gradient(0deg,#055096_0%,#4EB0E2_100%)] hover:bg-blue-700 transition duration-300"
      >
        <img src={insites} alt="Logo" className="h-3 w-6" />
        <span className="font-semibold text-white text-center text-xl flex-1">
          {title}
        </span>
        <span className="text-white">{isOpen ?
          <img src={arrowup} className="h-4 w-5 text-white" />
          : <img src={arrowdown} className="h-4 w-5" />
        }
        </span>

      </button>
      {isOpen && (
        <div className="p-4 bg-white text-black shadow-md">{children}</div>
      )}
    </div>
  );
};

export default function Dashboard() {
  const [retData, setRetData] = useState("");
  const [amcData, setAmcData] = useState("");
  const [amcdetails, setamcdetails] = useState("");
  const [lastPurchahed, setlastPurchahed] = useState("");
  const [sampoornaTotalCouponIssued, setSampoornaTotalCouponIssued] =
    useState("");
  const [sampoornaTotalCouponGenerated, setSampoornaTotalCouponGenerated] =
    useState("");
  const [lastServiceDateLoad, setlastServiceDateLoad] = useState("");
  const [totalVehicalsInsights, settotalVehicalsInsights] = useState("");

  const [sampoornaTotalCouponBalance, setsampoornaTotalCouponBalance] =
    useState("");
  const [sampoornaTotalCouponExpired, setsampoornaTotalCouponExpired] =
    useState("");
  const [totalComplaintsStatusOpen, settotalComplaintsStatusOpen] =
    useState("");
  const [sixMonthPurchaseQuantity, setsixMonthPurchaseQuantity] = useState("");
  const [sampoornaTotalCouponVailed, setsampoornaTotalCouponVailed] =
    useState("");
  const [amcContractDueNextOneMData, setamcContractDueNextOneMData] =
    useState("");
  const [vehiclesInsuranceExpeNintydays, setvehiclesInsuranceExpeNintydays] =
    useState("");
  const [ownershipLoadCount, setownershipLoadCount] = useState("");
  const [problemAreaWithDistinctChassis, setproblemAreaWithDistinctChassis] =
    useState("");
  const [problemAreaWithDistinctChassis1, setproblemAreaWithDistinctChassis1] =
    useState("");
  const [pendingcount, setPendingcount] = useState("");
  const [pendingcounttable, setPendingcounttable] = useState("");
  const [Amctabledata, setAmctabledata] = useState("");
  const [servicedue, setServicedue] = useState("");
  const [serviceduevalue, setServiceduevalue] = useState("");
  const [problemarea, setProblemarea] = useState("");
  const [couponissuetbdata, setCouponissuetbdata] = useState([]);
  const [lastpurchasedtb, setLastpurchasetb] = useState([]);
  const [lastservicetable, setLastservicetable] = useState([]);
  const [amcduetb, setAmcduetb] = useState([]);
  const [sevenyrtable, setSevenyeartable] = useState([]);
  const [ontimeddata, setOntimeddata] = useState(0);
  const [delayddata, setdelaydddata] = useState(0);
  const [sixqtytabledata, setSixqtytabledata] = useState(0);
  const [ontimetb, setOntimetb] = useState([]);
  const [vehicleinsight, setVehicleinsight] = useState("")

  const [
    vehiclesInsuranceExpeNintydaysvalue,
    setvehiclesInsuranceExpeNintydaysvalue,
  ] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const [isModalOpen5, setIsModalOpen5] = useState(false);
  const [isModalOpen6, setIsModalOpen6] = useState(false);
  const [isModalOpen7, setIsModalOpen7] = useState(false);
  const [isModalOpen8, setIsModalOpen8] = useState(false);
  const [isModalOpen9, setIsModalOpen9] = useState(false);
  const [isModalOpen10, setIsModalOpen10] = useState(false);
  const [isModalOpen11, setIsModalOpen11] = useState(false);
  const [isModalOpen12, setIsModalOpen12] = useState(false);
  const [isModalOpen13, setIsModalOpen13] = useState(false);


  let sumlastpurchase = 0;

  const [opencomptb, setOpencomptb] = useState([]);

  const [modalContent, setModalContent] = useState(null);

  const openModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleModalOpen1 = () => {
    setIsModalOpen1(true);
  };

  const handleCloseModal1 = () => {
    setIsModalOpen1(false);
  };

  const handleModalOpen8 = () => {
    setIsModalOpen8(true);
  };

  const handleCloseModal8 = () => {
    setIsModalOpen8(false);
  };
  const handleModalOpen5 = () => {
    setIsModalOpen5(true);
  };

  const handleCloseModal5 = () => {
    setIsModalOpen5(false);
  };

  const handleModalOpen6 = () => {
    setIsModalOpen6(true);
  };

  const handleCloseModal6 = () => {
    setIsModalOpen6(false);
  };

  const handleModalOpen2 = () => {
    setIsModalOpen2(true);
  };

  const handleCloseModal2 = () => {
    setIsModalOpen2(false);
  };

  const handleModalOpen3 = () => {
    setIsModalOpen3(true);
  };

  const handleCloseModal3 = () => {
    setIsModalOpen3(false);
  };

  const handleModalOpen4 = () => {
    setIsModalOpen4(true);
  };

  const handleCloseModal4 = () => {
    setIsModalOpen4(false);
  };

  const handleModalOpen7 = () => {
    setIsModalOpen7(true);
  };

  const handleCloseModal7 = () => {
    setIsModalOpen7(false);
  };

  const handleModalOpen9 = () => {
    setIsModalOpen9(true);
  };

  const handleCloseModal9 = () => {
    setIsModalOpen9(false);
  };

  const handleModalOpen10 = () => {
    setIsModalOpen10(true);
  };

  const handleCloseModal10 = () => {
    setIsModalOpen10(false);
  };

  const handleModalOpen11 = () => {
    setIsModalOpen11(true);
  };

  const handleCloseModal11 = () => {
    setIsModalOpen11(false);
  };

  const handleModalOpen12 = () => {
    setIsModalOpen12(true);
  };

  const handleCloseModal12 = () => {
    setIsModalOpen12(false);
  };

  const handleModalOpen13 = () => {
    setIsModalOpen13(true);
  };

  const handleCloseModal13 = () => {
    setIsModalOpen13(false);
  };
  const getRetoData = async (arn) => {
    // setLoading(true);
    try {
      const data = await fetchRetosCount(arn);
      setRetData(data);
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
      // setLoading(false);
    }
  };
  const getActiveAMCData = async (payload) => {
    // setLoading(true);
    try {
      const data = await fetchActiveAMCCount(payload);
      // setAmcData(data);
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
    }
  };



  const getproblemAreaWithDistinctChassis = async (payload1) => {
    try {
      const data = await fetchproblemAreaWithDistinctChassis(payload1);

      setproblemAreaWithDistinctChassis1(data[0]?.name?.value)

      let result = 0;

      if (data && Array.isArray(data.result) && data.result.length > 0) {
        result = data.result[0].doc_count ?? 0;
      }


      // console.log("Extracted doc_count:", result);
      setproblemAreaWithDistinctChassis(result);
    } catch (error) {
      console.error("Error fetching insurance data:", error);
    }
  };
  const gettotalVehicalsInsights = async (payload) => {
    try {
      const data = await fetchtotalVehicalsInsights(payload);
      settotalVehicalsInsights(data);
    } catch (error) {
      console.error("Error fetching ownership load count:", error);
    }
  };
  const getownershipLoadCount = async (payload1) => {
    try {
      const data = await fetchownershipLoadCount(payload1);
      // console.log("Raw response data:", data);

      // Accessing the second value: Count.value
      const count = data?.Count?.value;
      // console.log("Extracted count from Count.value:", count);

      setownershipLoadCount(count);
    } catch (error) {
      console.error("Error fetching ownership load count:", error);
    }
  };

  const getopencomptb = async (payload1, problem_area) => {
    try {
      const data = await fetchoprencomptable(payload1, problem_area);
      const tableData = data || [];
      setOpencomptb(tableData);
    } catch (error) {
      console.error("Error fetching open complaint table:", error);
    }
  };

  const getcouponissuedtb = async (payload1) => {
    try {
      const data = await fetchcouponissuedtb(payload1);
      const tableData = data || [];
      setCouponissuetbdata(tableData);
    } catch (error) {
      console.error("Error fetching open complaint table:", error);
    }
  };

  const getlastservicetb = async (payload1) => {
    try {
      const data = await fetchlastservicetb(payload1);
      const tableData = data || [];
      setLastservicetable(tableData);
    } catch (error) {
      console.error("Error fetching open complaint table:", error);
    }
  };

  const getamcContractDueNextOneMData = async (payload1) => {
    try {
      const data = await fetchamcContractDueNextOneMData(payload1);
      const count = data;
      setamcContractDueNextOneMData(count);
    } catch (error) {
      console.error("Error fetching AMC contract data:", error);
    }
  };

  const getsampoornaTotalCouponIssued = async (payload1) => {
    // setLoading(true);
    try {
      const data = await fetchsampoornaTotalCouponIssued(payload1);
      // console.log("data", data)
      setSampoornaTotalCouponIssued(data.Distinct_vehicle_count.value);
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
      // setLoading(false);
    }
  };

  const getvehicleAMcCountDetails = async (payload1) => {
    // setLoading(true);
    try {
      const data = await fetchvehicleAMcCountDetails(payload1);
      setamcdetails(data);
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
    }
  };

  const getontimetb = async (payload) => {
    // setLoading(true);
    try {
      const data = await fetchontimetb(payload);
      setOntimetb(data);
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
    }
  };

  // state

  const getVehicleseveryears = async (payload) => {
    try {
      const data = await fetchvehiclesevenyearstable(payload);
      // console.log("bucket data", data.buckets);

      setSevenyeartable(data.buckets);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
    }
  };


  // const getamccduetabledata = async (payload1) => {
  //   try {
  //     const data = await fetchamcduecontracttable(payload1);
  //     setAmcduetb(data);
  //   } catch (error) {
  //     console.error("Error fetching child data:", error);
  //   } finally {
  //   }
  // };

  const getAmcDueTableData = async (payload1) => {
    try {
      const data = await fetchamcduecontracttable(payload1);

      // Map API result to table-friendly format
      const formattedData =
        data?.map((item, index) => {
          const src = item._source;
          return {
            srNo: index + 1,
            serviceType: "AMC Contract",
            regNo: src.VEHICLE_REGISTRATION_NUMBER || "—",
            chassisNo: src.ASSET_NUMBER || "—",
            amcNumber: src.TM_AMC_NUMBER || "—",
            amcDueDate: src.TM_AMC_END_DATE || "—",
          };
        }) || [];

      setAmcduetb(formattedData); // ✅ now the table can render properly
    } catch (error) {
      console.error("Error fetching AMC Due Table data:", error);
    }
  };

  // const getlastPurchahed = async (arn) => {
  //   // setLoading(true);
  //   try {
  //     const data = await fetchlastPurchahed(arn);
  //     // data.map((item)=>item.doc_count)
  //     // setlastPurchahed(data?.map((item) => item.doc_count),
  //     setLastpurchasetb(data?.map((item) => item.doc_count)

  //     );
  //   } catch (error) {
  //     console.error("Error fetching child data:", error);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  const getlastPurchahed = async (payload1) => {
    try {
      const data = await fetchlastPurchahed(payload1);

      // If result is an array of items with doc_count
      let totalCount = 0;
      if (Array.isArray(data?.result)) {
        totalCount = data.result.reduce(
          (sum, item) => sum + (item.doc_count || 0),
          0
        );
      } else if (
        typeof data?.result === "object" &&
        data.result?.doc_count !== undefined
      ) {
        // single object case
        totalCount = data.result.doc_count;
      }

      setlastPurchahed(totalCount);
      setLastpurchasetb(data);
    } catch (error) {
      console.error("Error fetching last purchase data:", error);
      setlastPurchahed(0);
      setLastpurchasetb([]);
    }
  };

  const getsampoornaTotalCouponGenerated = async (payload1) => {
    // setLoading(true);
    try {
      const data = await fetchsampoornaTotalCouponGenerated(payload1);
      // data.map((item)=>item.doc_count)
      setSampoornaTotalCouponGenerated(
        data.Total_amount_coupon_generated.value
      );
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
      // setLoading(false);
    }
  };

  const getsampoornaTotalCouponBalance = async (payload1) => {
    try {
      const data = await fetchsampoornaTotalCouponBalance(payload1);
      const balance = data?.Total_amount_coupon_Balance_Active?.value;
      setsampoornaTotalCouponBalance(balance);
    } catch (error) {
      console.error("Error fetching coupon balance:", error);
    }
  };

  const getsampoornaTotalCouponVailed = async (payload1) => {
    try {
      const data = await fetchsampoornaTotalCouponVailed(payload1);
      const valid = data?.Total_amount_coupon_availed?.value;
      setsampoornaTotalCouponVailed(valid);
    } catch (error) {
      console.error("Error fetching coupon balance:", error);
    }
  };

  const getsampoornaTotalCouponExpired = async (payload1) => {
    // setLoading(true);
    try {
      const data = await fetchsampoornaTotalCouponExpired(payload1);

      // data.map((item)=>item.doc_count)
      setsampoornaTotalCouponExpired(data?.Total_amount_coupon_expired?.value);
    } catch (error) {
      console.error("Error fetching child data:", error);
    } finally {
      // setLoading(false);
    }
  };

  const getlastServiceDateLoad = async (payload1) => {
    try {
      const data = await fetchlastServiceDateLoad(payload1);
      // console.log("Fetched Data:", data);
      setlastServiceDateLoad(
        data?.max_date?.value_as_string || "No data available"
      );
    } catch (error) {
      console.error("Error fetching last service date:", error);
      setlastServiceDateLoad("Error fetching data");
    }
  };

  const gettotalComplaintsStatusOpen = async (payload1) => {
    try {
      const data = await fetchtotalComplaintsStatusOpen(payload1);
      // console.log("Fetched Data:", data);
      settotalComplaintsStatusOpen(data?.buckets[0]?.doc_count || 0);
    } catch (error) {
      console.error("Error fetching last service date:", error);
      settotalComplaintsStatusOpen("Error fetching data");
    }
  };

  const getsixMonthPurchaseQuantity = async (payload1) => {
    try {
      const data = await fetchsixMonthPurchaseQuantity(payload1);
      // console.log("Fetched Data:", data);
      setsixMonthPurchaseQuantity(data?.six_month_purchase_count?.value);
    } catch (error) {
      console.error("Error fetching last service date:", error);
    }
  };

  const getretrocount = async (payload) => {
    try {
      const data = await fetchretropendingcount(payload);
      const count = data?.value;
      setPendingcount(count);
    } catch (error) {
      console.error("Error fetching AMC contract data:", error);
    }
  };

  const getsixqtytable = async (payload1) => {
    try {
      const data = await fetchsixqtytable(payload1);
      const transformed =
        data?.result?.map((item) => ({
          dealer: item.key?.[0] || "—",
          ppl: item.key?.[1] || "—",
          pl: item.key?.[2] || "—",
          count: item.doc_count ?? 0,
          date: item.key?.[3]?.replace(/-/g, "-") || "—", // or format if needed
        })) || [];

      setSixqtytabledata(transformed);
    } catch (error) {
      console.error("Error fetching 60 days table data:", error);
    }
  };

  // const getretrotable = async (ParArn) => {
  //   try {
  //     const data = await fetchretropendingtabledata(ParArn);
  //     const count = data;
  //     setPendingcounttable(count)
  //   } catch (error) {
  //     console.error("Error fetching AMC contract data:", error);
  //   }
  // };

  const getretrotable = async (payload) => {
    try {
      const data = await fetchretropendingtabledata(payload);
      // console.log("Raw API response:", data);

      if (data?.key) {
        const transformed = [
          {
            Retro_Code: data.key.Retro_Code,
            Retro_Code_Desc: data.key.Retro_Code_Desc,
            Chassis_No: data.key.Chassis_No,
            Vehicle_Registration_No: data.key.Vehicle_Registration_No,
            Pending_Count: data.Pending_Chassis_Details?.value ?? 0,
          },
        ];

        // console.log("Transformed table data:", transformed);
        setPendingcounttable(transformed);
      } else {
        console.warn("No key found in response");
        setPendingcounttable([]);
      }
    } catch (error) {
      console.error("Error fetching retro table data:", error);
      setPendingcounttable([]);
    }
  };

  const getfreeservice = async (payload) => {
    try {
      const data = await fetchfreeSeriveCount(payload);
      // console.log("API response:", data);
      setServicedue(data || {}); // <-- use data directly
      setServiceduevalue(data?.servicing_due_count);
    } catch (error) {
      console.error("Error fetching free service data:", error);
    } finally {
    }
  };

  const getOntime = async (payload) => {
    try {
      const data = await fetchontime(payload);
      setOntimeddata(data.data.tata_on_time_total);
    } catch (error) {
      console.error("Error fetching free service data:", error);
    } finally {
    }
  };
  // console.log("API response:", ontimeddata);

  const getMoretime = async (payload) => {
    try {
      const data = await fetchdelaycards(payload);
      setdelaydddata(data.tataMoreTime);
    } catch (error) {
      console.error("Error fetching free service data:", error);
    } finally {
    }
  };
  // console.log("API response:", ontimeddata);

  const getproblemarea = async (payload) => {
    try {
      const data = await fetchinsightsproblem(payload);
      // console.log("API response:", data);
      setProblemarea(data || {}); // <-- use data directly
    } catch (error) {
      console.error("Error fetching free service data:", error);
    } finally {
    }
  };

  const getamcvalidcountt = async (payload) => {
    try {
      const data = await fetchamcvalidcount(payload);
      const count = data?.doc_count;
      // console.log("aamc", data);

      setAmcData(count);
    } catch (error) {
      console.error("Error fetching AMC contract data:", error);
    }
  };





  const getvehicleinsights = async (payload) => {
    try {
      const data = await fetchVehicalsInsights(payload);
      const count = data;
      // console.log("setVehicleinsight", data);

      setVehicleinsight(count);
    } catch (error) {
      console.error("Error fetching AMC contract data:", error);
    }
  };






















  const getamctable = async (payload) => {
    try {
      const data = await fetchamctable(payload);
      // console.log("Raw AMC API data:", data);

      // ✅ Directly use data itself
      if (data) {
        const transformed = [
          {
            totalNoVehicle: data.totalNoVehicle,
            amc_contract: data.amc_contract,
            amc_valid_count: data.amc_valid_count,
            notValidExpired: data.notValidExpired,
            expiredDueToPeriod: data.expiredDueToPeriod,
          },
        ];

        // console.log("✅ Transformed AMC table data:", transformed);
        setAmctabledata(transformed);
      } else {
        console.warn("⚠️ No data found in response");
        setAmctabledata([]);
      }
    } catch (error) {
      console.error("❌ Error fetching AMC table data:", error);
      setAmctabledata([]);
    }
  };
  const getvehiclesInsuranceExpeNintydays = async (payload) => {
    try {
      const data = await fetchvehiclesInsuranceExpeNintydays(payload);

      // Transform structure to match table columns
      const transformedData = [
        {
          totalNoVehicle: data?.result?.insuranceData?.doc_count || 0,
          insuranceAvaialble: data?.result?.insuranceAvaialble?.doc_count || 0,
          insuranceExpiring1: data?.result?.insuranceExpiring1?.doc_count || 0,
          insuranceExpiring2: data?.result?.insuranceExpiring2?.doc_count || 0,
          insuranceExpiring3: data?.result?.insuranceExpiring3?.doc_count || 0,
        },
      ];

      setvehiclesInsuranceExpeNintydays(transformedData);
      setvehiclesInsuranceExpeNintydaysvalue(data?.insuranceData?.doc_count);
    } catch (error) {
      console.error("Error fetching insurance data:", error);
    }
  };

  // console.log("lastpurchaseddata", lastpurchasedtb);

  lastpurchasedtb.map((item) => {
    sumlastpurchase = item.doc_count + sumlastpurchase;
  });


  const d1 = totalVehicalsInsights;
  const d2 = problemAreaWithDistinctChassis1;
  const d3 = (d2 / d1) * 100


  return (
    <div className="pl-4 p-1 pr-4 bg-gray-100">
      <AccordionItem
        title="Insights"
        getRetoData={getRetoData}
        getontimetb={getontimetb}
        getsixqtytable={getsixqtytable}
        getMoretime={getMoretime}
        getOntime={getOntime}
        getVehicleseveryears={getVehicleseveryears}
        getAmcDueTableData={getAmcDueTableData}
        getlastservicetb={getlastservicetb}
        getcouponissuedtb={getcouponissuedtb}
        getopencomptb={getopencomptb}
        getproblemarea={getproblemarea}
        getFreeService={getfreeservice}
        getretrotable={getretrotable}
        getamctable={getamctable}
        getproblemAreaWithDistinctChassis={getproblemAreaWithDistinctChassis}

        gettotalVehicalsInsights={gettotalVehicalsInsights}
        getownershipLoadCount={getownershipLoadCount}
        getvehiclesInsuranceExpeNintydays={getvehiclesInsuranceExpeNintydays}
        getamcContractDueNextOneMData={getamcContractDueNextOneMData}
        getsampoornaTotalCouponVailed={getsampoornaTotalCouponVailed}
        getretrocount={getretrocount}
        getfreeservice={getfreeservice}
        getsixMonthPurchaseQuantity={getsixMonthPurchaseQuantity}
        gettotalComplaintsStatusOpen={gettotalComplaintsStatusOpen}
        getlastServiceDateLoad={getlastServiceDateLoad}
        getsampoornaTotalCouponExpired={getsampoornaTotalCouponExpired}
        getsampoornaTotalCouponBalance={getsampoornaTotalCouponBalance}
        getsampoornaTotalCouponGenerated={getsampoornaTotalCouponGenerated}
        getActiveAMCData={getActiveAMCData}
        getvehicleAMcCountDetails={getvehicleAMcCountDetails}
        getlastPurchahed={getlastPurchahed}
        getsampoornaTotalCouponIssued={getsampoornaTotalCouponIssued}
        getamcvalidcountt={getamcvalidcountt}
        getvehicleinsights={getvehicleinsights}
      >
        {/* Main Dashboard Container */}
        <div className="grid lg:grid-cols-3 gap-4">
          {/* Vehicle Performance Insights (Takes Half Screen) */}
          <div className="bg-white rounded-lg shadow-md p-4 border lg:col-span-2">
            <h2 className="bg-[#267CB8] text-white text-lg font-semibold p-2 rounded-md">
              Vehicle Performance Insights
            </h2>
            <div className="block  md:grid grid-cols-3 gap-4 mt-4">
              <BasicModal
                open={isModalOpen}
                handleOpenModal={handleModalOpen}
                handleCloseModal={handleCloseModal}
                title={"Retro Pending Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen}
                  >
                    <InfoCard
                      icon="⚠️"
                      title="Pending Retros"
                      value={pendingcount}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <SimpleTable data={pendingcounttable} />
              </BasicModal>

              {/* <InfoCard icon="⚠️" title="Pending Retros" value={pendingcount} /> */}

              <BasicModal
                open={isModalOpen1}
                handleOpenModal={handleModalOpen1}
                handleCloseModal={handleCloseModal1}
                title={"AMC Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen1}
                  >
                    <InfoCard
                      icon="📄"
                      title="Active AMC Contracts"
                      value={`${amcData} Vehicles`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <AmcTable data={Amctabledata} />
              </BasicModal>

              <BasicModal
                open={isModalOpen6}
                handleOpenModal={handleModalOpen6}
                handleCloseModal={handleCloseModal6}
                title={" Last Purchase Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen6}
                  >
                    <InfoCard
                      icon="🚗"
                      title="Last Purchase"
                      value={`${sumlastpurchase} Vehicles`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                      extra="on 16-01-2022"
                    />
                  </button>
                }
              >
                <Lastpurchasetb data={lastpurchasedtb} />
              </BasicModal>

              <BasicModal
                open={isModalOpen7}
                handleOpenModal={handleModalOpen7}
                handleCloseModal={handleCloseModal7}
                title={" Last Service Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen7}
                  >
                    <InfoCard
                      icon="🛠️"
                      title="Last Serviced"
                      value={`${lastServiceDateLoad}`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <Lastservicetable data={lastservicetable} />
              </BasicModal>

              <BasicModal
                open={isModalOpen4}
                handleOpenModal={handleModalOpen4}
                handleCloseModal={handleCloseModal4}
                title={" Open Complaint Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen4}
                  >
                    <InfoCard
                      icon="📢"
                      title="Open Complaints"
                      value={`${totalComplaintsStatusOpen}`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <Opencomplainttb data={opencomptb} />
              </BasicModal>

              <BasicModal
                open={isModalOpen2}
                handleOpenModal={handleModalOpen2}
                handleCloseModal={handleCloseModal2}
                title={"Insurance Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen2}
                  >
                    <InfoCard
                      icon="🛡️"
                      title="Insurance Expiring in 90 Days"
                      value={`${vehiclesInsuranceExpeNintydaysvalue}`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <InsTable data={vehiclesInsuranceExpeNintydays} />
              </BasicModal>
            </div>
            <div className="grid lg:grid-cols-2 gap-4 mt-2">
              <BasicModal
                open={isModalOpen8}
                handleOpenModal={handleModalOpen8}
                handleCloseModal={handleCloseModal8}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen8}
                  >
                    <InfoCard
                      icon="🗓️"
                      title="AMC Due in Next Month"
                      value={`${amcContractDueNextOneMData}`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <Amcduenextmonthtb />
              </BasicModal>

              <BasicModal
                open={isModalOpen11}
                handleOpenModal={handleModalOpen11}
                handleCloseModal={handleCloseModal11}
                title={""}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen11}
                  >
                    <InfoCard
                      icon="🛍️"
                      title="Purchased in Last 6 Months"
                      value={`${sixMonthPurchaseQuantity}`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <Sixtydaystable data={sixqtytabledata} />
              </BasicModal>

              <BasicModal
                open={isModalOpen3}
                handleOpenModal={handleModalOpen3}
                handleCloseModal={handleCloseModal3}
                title={" Service Details"}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen3}
                  >
                    <InfoCard
                      icon="🔧"
                      title="Service Due in Next Month"
                      value={`${serviceduevalue ?? 0} `}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                <ServiceTable data={servicedue} />
              </BasicModal>

              <BasicModal
                open={isModalOpen9}
                handleOpenModal={handleModalOpen9}
                handleCloseModal={handleCloseModal9}
                title={" "}
                trigger={
                  <button
                    className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                    onClick={handleModalOpen9}
                  >
                    <InfoCard
                      icon="🚚"
                      title="Vehicles Age > 7 Years"
                      value={`${ownershipLoadCount}`}
                      icon2={
                        <img
                          src={mousepointer}
                          alt="open modal"
                          className="h-4 w-4"
                        />
                      }
                    />
                  </button>
                }
              >
                {/* <Vehicltable data={sevenyrtable} /> */}
                <Vehicltable data={sevenyrtable} />
              </BasicModal>
            </div>
          </div>

          {/* Sampoorna Seva Compensation */}
          <div className="bg-white rounded-lg shadow-md p-4 border">
            <h2 className="bg-[#267CB8] text-white text-lg font-semibold p-2 rounded-md">
              Sampoorna Seva Compensation
            </h2>
            <div className="mt-1 space-y-1">
              <div className="mt-1 flex justify-between text-gray-700">
                <BasicModal
                  open={isModalOpen5}
                  handleOpenModal={handleModalOpen5}
                  handleCloseModal={handleCloseModal5}
                  title={"Coupon Issue Detail"}
                  trigger={
                    <button
                      className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                      onClick={handleModalOpen5}
                    >
                      <div className="  flex gap-2 font-medium ">
                        Coupons Issued: {`${sampoornaTotalCouponIssued}`}{" "}
                        {
                          <img
                            src={mousepointer}
                            alt="open modal"
                            className="h-4 w-4"
                          />
                        }
                      </div>
                    </button>
                  }
                >
                  <Couponissuedtb data={couponissuetbdata} />
                </BasicModal>

                <span className="font-medium">
                  Total Amount:{" "}
                  <span className="font-semibold">{`${sampoornaTotalCouponGenerated}`}</span>
                </span>
              </div>
              <div className="flex justify-between mt-2 gap-1">
                <StatusBadge
                  color="green"
                  text={`Rs.${sampoornaTotalCouponVailed} Available`}
                />
                <StatusBadge
                  color="red"
                  text={`Rs.${sampoornaTotalCouponExpired} Expired `}
                />
                <StatusBadge
                  color="gray"
                  text={`Rs.${sampoornaTotalCouponBalance} Balance`}
                />
              </div>
            </div>
            {/* Vehicle Complaint Report */}
            <h2 className="bg-[#267CB8] text-white text-lg font-semibold p-2 rounded-md mt-1">
              Vehicle Complaint Report
            </h2>
            <div className="mt-1 space-y-2">
              <div className="mt-1 text-center">
                <p className="text-red-600 text-lg font-bold">
                  ❗ POOR PICK-UP
                </p>
                <p className="text-gray-700 font-medium">
                  {d3.toFixed(2)} % of vehicles have this issue.
                </p>
                <div className="mt-2 flex justify-between text-gray-700">
                  <p>
                    🚗 Total Vehicles:{`${amcdetails.totalVehicles} Vehicles`}
                    <span className="font-semibold"></span>
                  </p>
                  <p>
                    {/* ⚠️ Complaints: <span className="font-semibold">{`${problemAreaWithDistinctChassis}`}</span> */}
                  </p>
                </div>
              </div>
            </div>

            {/* <h2 className="bg-[#267CB8] text-white text-lg font-semibold p-2 rounded-md mt-1">
              Vehicle Complaint Report
            </h2> */}
            <div className="mt-1 space-y-2">
              <div className="mt-1 text-center">
                <p className="text-red-600 text-lg font-bold">
                  ❗ {`${problemarea?.key ?? "No One"}`} has Highest Complaints
                </p>
                <p className="text-gray-700 font-medium">
                  {problemarea?.doc_count ?? 0} complaints against Total Number
                  of Vehicle
                </p>
              </div>
            </div>
            {/* Sampoorna Seva Job Cards */}
            <h2 className="bg-[#267CB8] text-white text-lg font-semibold p-2 rounded-md mt-4">
              Sampoorna Seva Job Cards
            </h2>
            <div className="mt-1 space-y-2">
              <div className="flex justify-between items-center mt-4">
                <BasicModal
                  open={isModalOpen12}
                  handleOpenModal={handleModalOpen12}
                  handleCloseModal={handleCloseModal12}
                  title={""}
                  trigger={
                    <button
                      className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                      onClick={handleModalOpen12}
                    >

                      📞 On-Time Delivered: {ontimeddata ?? 0}



                    </button>
                  }
                >
                  <Ontimetable data={ontimetb} />
                </BasicModal>

                <div className=" font-semibold text-sm">
                  <BasicModal
                    open={isModalOpen13}
                    handleOpenModal={handleModalOpen13}
                    handleCloseModal={handleCloseModal13}
                    title={""}
                    trigger={
                      <button
                        className="block w-full text-sm text-center  py-2 px-4 hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
                        onClick={handleModalOpen13}
                      >
                        <div className="text-orange-500">
                          ⚠️ Delayed Job Cards: {delayddata ?? 0}
                        </div>




                      </button>
                    }
                  >
                    <Moretimetable />
                  </BasicModal>
                </div>
              </div>
              <div className="w-full bg-gray-300 rounded-full h-3 mt-4">
                <div
                  className="bg-green-500 h-3 rounded-full"
                  style={{ width: "63.6%" }}
                ></div>
              </div>
              <p className="text-center text-gray-700 mt-2">
                {/* 63.6% jobs delivered on time */}
              </p>
            </div>
          </div>
        </div>
      </AccordionItem>
    </div>
  );
}

// InfoCard Component
// InfoCard Component
const InfoCard = ({ icon, icon2, title, value, extra }) => (
  <div className="flex items-center justify-between bg-gray-100 p-3 rounded-lg shadow-sm">
    {/* Left content */}
    <div className="flex items-center gap-2">
      <span className="text-xl">{icon}</span>
      <div>
        <p className="text-gray-700 font-semibold">{title}</p>
        <p className="text-gray-600">{value}</p>
        {extra && <p className="text-sm text-gray-500">{extra}</p>}
      </div>
    </div>

    {/* Right icon */}
    {icon2 && <span className="ml-2">{icon2}</span>}
  </div>
);

// StatusBadge Component
const StatusBadge = ({ color, text }) => {
  const bgColor = {
    green: "bg-green-500",
    red: "bg-red-500",
    gray: "bg-gray-400",
  }[color];

  return (
    <span className={`${bgColor} text-white px-3 py-1 rounded-md text-sm`}>
      {text}
    </span>
  );
};
